module.exports = __webpack_public_path__ + "img/35.8f80c2fd.jpg";